import { useMutation } from "urql";

import { UpdateCollectionActivityDocument } from "../../../graphql/generated.ts";

export function useUpdateCollectionActivity() {
  return useMutation(UpdateCollectionActivityDocument);
}
